var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 101.894,
    height: 80.014,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-32 -80.1)",
    fill: "#ffba60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130.71 142.828H35.184a3.184 3.184 0 1 0 0 6.368h95.526a3.184 3.184 0 1 0 0-6.368zm0 10.917H35.184a3.184 3.184 0 1 0 0 6.368h95.526a3.184 3.184 0 1 0 0-6.368zm-4.8-73.645H39.983A8.008 8.008 0 0 0 32 88.083v40.439a8.008 8.008 0 0 0 7.983 7.983h85.928a8.008 8.008 0 0 0 7.983-7.983V88.083a8.008 8.008 0 0 0-7.983-7.983zm-75.26 49.127h-8.188a3.184 3.184 0 1 1 0-6.368h8.188a3.184 3.184 0 1 1 0 6.368zm0-35.481h-8.188a3.184 3.184 0 1 1 0-6.368h8.188a3.184 3.184 0 1 1 0 6.368zm32.3 32.751a18.2 18.2 0 1 1 18.2-18.2A18.219 18.219 0 0 1 82.947 126.5zm40.485 2.729h-8.188a3.184 3.184 0 1 1 0-6.368h8.188a3.184 3.184 0 1 1 0 6.368zm0-35.481h-8.188a3.184 3.184 0 1 1 0-6.368h8.188a3.184 3.184 0 1 1 0 6.368z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 12.054,
    cy: 12.054,
    rx: 12.054,
    ry: 12.054,
    transform: "translate(70.893 96.68)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.b96e4d4d51ae3fb8fa3be917b8e40b79.svg";
export { ForwardRef as ReactComponent };